export const placeHolder = {
    page: 'crop',
    subtitle: '支持批量裁切图片，高效实现组图投放',
    image: 'https://feed-image.baidu.com/0/pic/533030698_1549823988_-56109884.png'
};

export const suggestImg = [{
    url: 'https://feed-image.baidu.com/0/pic/-677173041_1768763072_-970901219.jpg',
    width: 2048,
    height: 1365
}, {
    url: 'https://feed-image.baidu.com/0/pic/327114197_1582000405_-1628271697.jpg',
    width: 2048,
    height: 1365
}, {
    url: 'https://feed-image.baidu.com/0/pic/1599803316_-340761796_-1150279700.jpg',
    width: 2048,
    height: 1365
}];

export const sizeOptions = [
     {
        value: '16:9',
        label: '16:9',
        children: [
            {
                value: '1140*640',
                label: '1140*640'
            }, {
                value: '1280*720',
                label: '1280*720'
            }, {
                value: '1600*900',
                label: '1600*900'
            }, {
                value: '1920*1080',
                label: '1920*1080'
            }
        ]
    }, {
        value: '9:16',
        label: '9:16',
        children: [
            {
                value: '1080*1920',
                label: '1080*1920'
            }, {
                value: '1242*2208',
                label: '1242*2208'
            }, {
                value: '720*1280',
                label: '720*1280'
            }
        ]
    }, {
        value: '4:3',
        label: '4:3',
        children: [
            {
                value: '800*600',
                label: '800*600'
            }
            // , {
            //     value: '120*90',
            //     label: '120*90'
            // }
        ]
    }, {
        value: '3:4',
        label: '3:4',
        children: [
            {
                value: '600*800',
                label: '600*800'
            }
        ]
    }, {
        value: '1:1',
        label: '1:1',
        children: [
            {
                value: '600*600',
                label: '600*600'
            }
            // , {
            //     value: '240*240',
            //     label: '240*240'
            // }, {
            //     value: '220*220',
            //     label: '220*220'
            // }, {
            //     value: '360*360',
            //     label: '360*360'
            // }, {
            //     value: '480*480',
            //     label: '480*480'
            // }, {
            //     value: '300*300',
            //     label: '300*300'
            // }
        ]
    }, {
        value: '3:1',
        label: '3:1',
        children: [
            {
                value: '1200*400',
                label: '1200*400'
            }, {
                value: '900*300',
                label: '900*300'
            }
        ]
    }
];

export const VERTICAL = 'vertical';
export const HORIZONTAL = 'horizontal';
export const AUTOSIZE = 'autoSize';
export const FIXEDRATIO = 'fixedRatio';
export const SMARTCROPTYPE = 'smart';
export const AVERAGECROPTYPE = 'average';
export const MAX_IMAGE_INPUT_SIZE = 2000;
export const MIN_IMAGE_INPUT_SIZE = 80;
export const MIN_IMAGE_RATIO = 0.3;
export const MAX_IMAGE_RATIO = 3;

// 裁切配置
export const cropConfigItems = [
    {
        vertical: 1, // 纵切份数
        horizontal: 1, // 横切份数
        value: 0,
        url: 'https://qiaojiang.bj.bcebos.com/fe/static/images/crop/crop-h1-v1.png',
        activeUrl: 'https://qiaojiang.bj.bcebos.com/fe/static/images/crop/crop-h1-v1-active.png'
    },
    {
        vertical: 1,
        horizontal: 2,
        value: 1,
        url: 'https://qiaojiang.bj.bcebos.com/fe/static/images/crop/crop-h2-v1.png',
        activeUrl: 'https://qiaojiang.bj.bcebos.com/fe/static/images/crop/crop-h2-v1-active.png'
    },
    {
        vertical: 2,
        horizontal: 1,
        value: 2,
        url: 'https://qiaojiang.bj.bcebos.com/fe/static/images/crop/crop-h1-v2.png',
        activeUrl: 'https://qiaojiang.bj.bcebos.com/fe/static/images/crop/crop-h1-v2-active.png'
    },
    {
        vertical: 1,
        horizontal: 3,
        value: 3,
        url: 'https://qiaojiang.bj.bcebos.com/fe/static/images/crop/crop-h3-v1.png',
        activeUrl: 'https://qiaojiang.bj.bcebos.com/fe/static/images/crop/crop-h3-v1-active.png'
    },
    {
        vertical: 3,
        horizontal: 1,
        value: 4,
        url: 'https://qiaojiang.bj.bcebos.com/fe/static/images/crop/crop-h1-v3.png',
        activeUrl: 'https://qiaojiang.bj.bcebos.com/fe/static/images/crop/crop-h1-v3-active.png'
    },
    {
        vertical: 2,
        horizontal: 2,
        value: 5,
        url: 'https://qiaojiang.bj.bcebos.com/fe/static/images/crop/crop-h2-v2.png',
        activeUrl: 'https://qiaojiang.bj.bcebos.com/fe/static/images/crop/crop-h2-v2-active.png'
    },
    {
        vertical: 1,
        horizontal: 4,
        value: 6,
        url: 'https://qiaojiang.bj.bcebos.com/fe/static/images/crop/crop-h4-v1.png',
        activeUrl: 'https://qiaojiang.bj.bcebos.com/fe/static/images/crop/crop-h4-v1-active.png'
    },
    {
        vertical: 4,
        horizontal: 1,
        value: 7,
        url: 'https://qiaojiang.bj.bcebos.com/fe/static/images/crop/crop-h1-v4.png',
        activeUrl: 'https://qiaojiang.bj.bcebos.com/fe/static/images/crop/crop-h1-v4-active.png'
    },
    {
        vertical: 2,
        horizontal: 3,
        value: 8,
        url: 'https://qiaojiang.bj.bcebos.com/fe/static/images/crop/crop-h3-v2.png',
        activeUrl: 'https://qiaojiang.bj.bcebos.com/fe/static/images/crop/crop-h3-v2-active.png'
    },
    {
        vertical: 3,
        horizontal: 2,
        value: 9,
        url: 'https://qiaojiang.bj.bcebos.com/fe/static/images/crop/crop-h2-v3.png',
        activeUrl: 'https://qiaojiang.bj.bcebos.com/fe/static/images/crop/crop-h2-v3-active.png'
    },
    {
        vertical: 3,
        horizontal: 3,
        value: 10,
        url: 'https://qiaojiang.bj.bcebos.com/fe/static/images/crop/crop-h3-v3.png',
        activeUrl: 'https://qiaojiang.bj.bcebos.com/fe/static/images/crop/crop-h3-v3-active.png'
    },
    {
        vertical: 4,
        horizontal: 2,
        value: 11,
        url: 'https://qiaojiang.bj.bcebos.com/fe/static/images/crop/crop-new-h2-v4.png',
        activeUrl: 'https://qiaojiang.bj.bcebos.com/fe/static/images/crop/crop-new-h2-v4-active.png'
    },
    {
        vertical: 2,
        horizontal: 4,
        value: 12,
        url: 'https://qiaojiang.bj.bcebos.com/fe/static/images/crop/crop-new-h4-v2.png',
        activeUrl: 'https://qiaojiang.bj.bcebos.com/fe/static/images/crop/crop-new-h4-v2-active.png'
    },
    {
        vertical: 3,
        horizontal: 4,
        value: 13,
        url: 'https://qiaojiang.bj.bcebos.com/fe/static/images/crop/crop-new-h4-v3.png',
        activeUrl: 'https://qiaojiang.bj.bcebos.com/fe/static/images/crop/crop-new-h4-v3-active.png'
    },
    {
        vertical: 4,
        horizontal: 3,
        value: 14,
        url: 'https://qiaojiang.bj.bcebos.com/fe/static/images/crop/crop-new-h3-v4.png',
        activeUrl: 'https://qiaojiang.bj.bcebos.com/fe/static/images/crop/crop-new-h3-v4-active.png'
    },
    {
        vertical: 4,
        horizontal: 4,
        value: 15,
        url: 'https://qiaojiang.bj.bcebos.com/fe/static/images/crop/crop-new-h4-v4.png',
        activeUrl: 'https://qiaojiang.bj.bcebos.com/fe/static/images/crop/crop-new-h4-v4-active.png'
    }
];

export const smartRatioOptions = [
    {
        label: '1:1',
        value: '1:1'
    },
    {
        label: '3:1',
        value: '3:1'
    },
    {
        label: '16:9',
        value: '16:9'
    },
    {
        label: '4:3',
        value: '4:3'
    },
    {
        label: '9:16',
        value: '9:16'
    },
    {
        label: '3:2',
        value: '3:2'
    },
    {
        label: '2:1',
        value: '2:1'
    }
];

export const smartRatioSizeOptions = {
    '1:1': [
        {
            label: '600*600',
            value: '600*600'
        },
        {
            label: '240*240',
            value: '240*240'
        },
        {
            label: '220*220',
            value: '220*220'
        },
        {
            label: '360*360',
            value: '360*360'
        },
        {
            label: '480*480',
            value: '480*480'
        },
        {
            label: '300*300',
            value: '300*300'
        }
    ],
    '3:1': [
        {
            label: '1200*400',
            value: '1200*400'
        },
        {
            label: '900*300',
            value: '900*300'
        }
    ],
    '4:3': [
        {
            label: '800*600',
            value: '800*600'
        },
        {
            label: '120*90',
            value: '120*90'
        }
    ],
    '16:9': [
        {
            label: '1140*640',
            value: '1140*640'
        },
        {
            label: '1280*720',
            value: '1280*720'
        },
        {
            label: '1600*900',
            value: '1600*900'
        },
        {
            label: '1920*1080',
            value: '1920*1080'
        }
    ],
    '9:16': [
        {
            label: '1080*1920',
            value: '1080*1920'
        },
        {
            label: '1242*2208',
            value: '1242*2208'
        },
        {
            label: '720*1280',
            value: '720*1280'
        }
    ],
    '3:2': [
        {
            label: '370*245',
            value: '370*245'
        },
        {
            label: '960*640',
            value: '960*640'
        },
        {
            label: '1200*800',
            value: '1200*800'
        },
        {
            label: '900*600',
            value: '900*600'
        },
        {
            label: '300*200',
            value: '300*200'
        }
    ],
    '2:1': [
        {
            label: '800*400',
            value: '800*400'
        },
        {
            label: '600*300',
            value: '600*300'
        }
    ]
};